import { RESET_STATE } from 'store/global/actions';

import { LOAN_APPLICATION_ACTION_TYPE } from '../actions';

const initialState = [];

const relatedLoansReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_APPLICATION_ACTION_TYPE.GET_RELATED_LOANS:
      return payload || state;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default relatedLoansReducer;
